import * as React from "react";

import { IntercomContextValues } from "./types";

const IntercomContext = React.createContext<IntercomContextValues | undefined>(undefined);

// eslint-disable-next-line import/no-default-export
export default IntercomContext;
